import { patientTopCard } from '@shared/helpers/pdf-patient-card.helper';

export const buildContentPdfEyeExam = (paperwork, group) => {
  const {rows} = group;

  const eyeExaBuildPdf = rows.map((exam) => {
    const {od, os, diagnosis, exams, observations} = exam;
    const DIAGNOSIS = diagnosis.map((diag) => (diag ? { text: `${diag}`, bold: true } : null));
    const EXAMS                                    = exams.map((exm) => {
      //validaciones en los campos booleanos
      let ODI = `${exm.odi}`;
      if (exm.odi === false) ODI = 'NO';
      else ODI = 'SI';

      let SS24 = `${exm.computerizedCampimetry.ss24x2}`;
      if (exm.computerizedCampimetry.ss24x2 === false) SS24 = 'NO';
      else SS24 = 'SI';

      let SS10 = `${exm.computerizedCampimetry.ss10x2}`;
      if (exm.computerizedCampimetry.ss10x2 === false) SS10 = 'NO';
      else SS10 = 'SI';

      let OTHER = `${exm.computerizedCampimetry.other}`;
      if (exm.computerizedCampimetry.other === false) OTHER = 'NO';
      else OTHER = 'SI';

      let ECOBIO = `${exm.biometryIntraocularLensCalculation.ecobiometrics}`;
      if (exm.biometryIntraocularLensCalculation.ecobiometrics === false) ECOBIO = 'NO';
      else ECOBIO = 'SI';

      let IOL = `${exm.biometryIntraocularLensCalculation.iolMaster}`;
      if (exm.biometryIntraocularLensCalculation.iolMaster === false) IOL = 'NO';
      else IOL = 'SI';

      let MACULA = `${exm.retinography.macula}`;
      if (exm.retinography.macula === false) MACULA = 'NO';
      else MACULA = 'SI';

      let OPTICO = `${exm.retinography.optic}`;
      if (exm.retinography.optic === false) OPTICO = 'NO';
      else OPTICO = 'SI';

      let AUTO_FLUO = `${exm.retinography.autoFluo}`;
      if (exm.retinography.autoFluo === false) AUTO_FLUO = 'NO';
      else AUTO_FLUO = 'SI';

      let ONE_DAY = `${exm.aplanaticStressCurve.oneDay}`;
      if (exm.aplanaticStressCurve.oneDay === false) ONE_DAY = 'NO';
      else ONE_DAY = 'SI';

      let TWO_DAYS = `${exm.aplanaticStressCurve.twoDays}`;
      if (exm.aplanaticStressCurve.twoDays === false) TWO_DAYS = 'NO';
      else TWO_DAYS = 'SI';

      let PENTACAM = `${exm.cornealTopography.pentacam}`;
      if (exm.cornealTopography.pentacam === false) PENTACAM = 'NO';
      else PENTACAM = 'SI';

      let TOPOLYZER = `${exm.cornealTopography.topolyzer}`;
      if (exm.cornealTopography.topolyzer === false) TOPOLYZER = 'NO';
      else TOPOLYZER = 'SI';

      let EST_LAGRIMA = `${exm.cornealTopography.estLagrima}`;
      if (exm.cornealTopography.estLagrima === false) EST_LAGRIMA = 'NO';
      else EST_LAGRIMA = 'SI';

      let D = `${exm.angiography.d}`;
      if (exm.angiography.d === false) D = 'NO';
      else D = 'SI';

      let I = `${exm.angiography.i}`;
      if (exm.angiography.i === false) I = 'NO';
      else I = 'SI';

      let FLUOR = `${exm.angiography.fluorescein}`;
      if (exm.angiography.fluorescein === false) FLUOR = 'NO';
      else FLUOR = 'SI';

      let INDOCAININE = `${exm.angiography.indocainine}`;
      if (exm.angiography.indocainine === false) INDOCAININE = 'NO';
      else INDOCAININE = 'SI';

      let MACULAR = `${exm.opticCoherenceTomography.macular}`;
      if (exm.opticCoherenceTomography.macular === false) MACULAR = 'NO';
      else MACULAR = 'SI';

      let OPT_NERVE = `${exm.opticCoherenceTomography.opticNerve}`;
      if (exm.opticCoherenceTomography.opticNerve === false) OPT_NERVE = 'NO';
      else OPT_NERVE = 'SI';

      let FRONT_POLE = `${exm.opticCoherenceTomography.frontPole}`;
      if (exm.opticCoherenceTomography.frontPole === false) FRONT_POLE = 'NO';
      else FRONT_POLE = 'SI';
      let subFrm = {};

      if (exm.name === 'CAMPO VISUAL GOLDMAN') subFrm = [{text: ` ODI: ${ODI} - Solo: ${exm.solo}`}];

      if (exm.name === 'CAMPIMETRÍA COMPUTARIZADA AMBOS OJOS')
        subFrm = [
          {
            text: ` SS24-2: ${SS24} - SS10-2: ${SS10} - OTRO: ${OTHER}`,
          },
        ];

              if (exm.name === 'CAMPIMETRÍA COMPUTARIZADA UN OJO')
        subFrm = [
          {
            text: `Solo: ${exm.solo} - SS24-2: ${SS24} - SS10-2: ${SS10} - OTRO: ${OTHER}`,
          },
        ];

      if (exm.name === 'BIOMETRÍA CON CÁLCULO DE LENTE INTRAOCULAR, AMBOS OJOS')
        subFrm = [{text: ` IOL MASTER: ${IOL} - ECOBIOMETRÍA ULTRASÓNICA: ${ECOBIO}`}];

      if (exm.name === 'RETINOGRAFÍA')
        subFrm = [{text: ` MÁCULA: ${MACULA} - N. ÓPTICO: ${OPTICO} - AUTO FLUO (BAF): ${AUTO_FLUO}`}];

      if (exm.name === 'CURVA DE TENSIÓN APLANATICA') subFrm = [{text: ` 1 DÍA: ${ONE_DAY} - 2 DÍAS: ${TWO_DAYS}`}];

      if (exm.name === 'TOPOGRAFÍA CORNEAL COMPUTARIZADA C/OJO')
        subFrm = [{text: ` PENTACAM: ${PENTACAM} - TOPOLYZER: ${TOPOLYZER} - EST. LÁGRIMA: ${EST_LAGRIMA}`}];

      if (exm.name === 'ANGIOGRAFÍA DE RETINA')
        subFrm = [
          {
           text: ` PRIMERO: ${exm.angiography.first ?? ''} - D: ${D} - I: ${I} - FLUORESCEINA: ${FLUOR} - INDOCIANINA: ${INDOCAININE}`,
          },
        ];

      if (exm.name === 'OCT: TOMOGRAFÍA DE COHERENCIA ÓPTICA')
        subFrm = [{text: ` MACULAR: ${MACULAR} - NERVIO ÓPTICO: ${OPT_NERVE} - POLO ANTERIOR: ${FRONT_POLE}`}];

      const fields = {...exm};

      delete fields.id;
      delete fields.name;

      return [exm.id, exm.name, subFrm];
    });
    let EXAMS_TABLE                                = {
      table: {
        headerRows: 1,
        widths    : [70, 'auto', '*'],

        body: [['Cod. Fonasa', 'Examen', ''], ...EXAMS],
      },
    };

    if (!exams.length) EXAMS_TABLE = undefined;

    return [
      {text: `LENTES P/C:`, bold: true, alignment: 'justify', fontSize: 16},
      {canvas: [{type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1}]},
      {text: '\n'},

      {
        layout: 'noBorders',
        table : {headerRows: 1, widths: [60, '*', 60, '*'], body: [['OD:', `${od}`, 'OI:', `${os}`]]},
      },
      {text: `Diagnóstico:`},
      ...DIAGNOSIS,
      {text: '\n\n'},
      EXAMS_TABLE,
      {text: '\n\n'},
      {text: `Observaciones:`},
      { text: `${observations || ''}`, bold: true, alignment: 'justify' },
    ];
  });

  return [...patientTopCard(paperwork), eyeExaBuildPdf];
};
